
import React from "react";
import { Route, Redirect } from "react-router-dom";
import jwt from 'jwt-decode'
import AuthService from '../../services/AuthService';
import UrlHelper from '../../Helpers/urlHelper';

const RouterGuard = ({ component: Component, adminRoute = false, ...rest }) => (
    <Route {...rest} render={(props) => (
        canAccess(adminRoute)
            ? <Component {...props} />
            : <Redirect to={{
                pathname: buildUri(),
                state: { from: props.location }
            }} />
    )} />
);

const canAccess = (adminRoute) => {
    return AuthService.isAuthenticated() && (adminRoute ? haveNSCEscolaAdmin() : haveNSCEscola());
}

const haveNSCEscola = () => {
    const { data } = AuthService.getData();
    return !!data.id_token && /(^|;)\s*(NSC_ESCOLA)\s*($|;)/.test((jwt(data.id_token))['nsc:products']);
}

const haveNSCEscolaAdmin = () => {
    const { data } = AuthService.getData();
    return !!data.id_token && /(^|;)\s*(NSC_ESCOLA_ADMIN)\s*($|;)/.test((jwt(data.id_token))['nsc:flags']);
}

const buildUri = () => {
    if (!AuthService.isAuthenticated()) {
        window.location.href = UrlHelper.buildLoginUrl();
        return;
    }
    return '/blocked';
}

export default RouterGuard;

